import axios from "axios";
import { API_URL } from "../constants";
import { PermissionCatalogueEntry, PermissionsOverview } from "types/Permissions";

/** GET /:companyId/permissions — the list of rights and who holds each. Master only. */
export async function fetchPermissionsOverview(
  companyId: string
): Promise<PermissionsOverview> {
  const res = await axios.get(`${API_URL}/${companyId}/permissions`);
  return res.data;
}

/** The list of rights alone, for forms that only need to offer them. */
export async function fetchPermissionCatalogue(
  companyId: string
): Promise<PermissionCatalogueEntry[]> {
  return (await fetchPermissionsOverview(companyId)).catalogue;
}

/**
 * PUT /:companyId/users/:userId/permissions — replaces the person's whole
 * manual list. `expected` is the list as the caller loaded it: if someone
 * changed it meanwhile the server answers 409 STALE_PERMISSIONS instead of
 * overwriting. (The answer is what they effectively hold now; callers reload.)
 */
export async function setUserManualPermissions(
  companyId: string,
  userId: string,
  permissions: string[],
  expected: string[]
): Promise<void> {
  await axios.put(`${API_URL}/${companyId}/users/${userId}/permissions`, {
    permissions,
    expected,
  });
}
